import './Footer.css'

const Footer = () => {
    return (
      <footer className="footer">
        <p className="footer-text">www.elabuelowine.com</p>
        <img src="/Image/abuelo.png" />
      </footer>
    );
  };


export default Footer
